import { request } from "./request.js";

export async function change(data) {
    return await request("/password/change", data, "POST");
}
